module.exports = __webpack_public_path__ + "static/media/BulkReturn1.1c63572c.png";